module.exports = __webpack_public_path__ + "media/images/icons/create-venue-d8b618190ba5352f87dfec8552d79d9a.svg";